import '../css/index.less';

console.log('hello')

// Squirrel text spinning functionality
document.addEventListener('DOMContentLoaded', () => {
    const squirrelText = document.querySelector('.squirrel-text');
    if (!squirrelText) return;

    let isDragging = false;
    let currentRotation = 0;
    let velocity = 0;
    let lastX = 0;
    let lastTime = 0;
    let animationId = null;

    const friction = 0.98; // Slows down the spin
    const minVelocity = 0.1; // Stop threshold

    function updateShadow(rotation) {
        // Calculate shadow offset based on rotation
        // As the image rotates, the shadow shifts to simulate lighting from above
        const normalizedAngle = normalizeAngle(rotation);
        const radians = (normalizedAngle * Math.PI) / 180;
        
        // Shadow shifts left/right based on which way the image is facing
        const shadowX = Math.sin(radians) * 15;
        // Shadow gets smaller when image is edge-on, larger when facing
        const shadowBlur = 6 + Math.abs(Math.cos(radians)) * 10;
        const shadowOpacity = 0.2 + Math.abs(Math.cos(radians)) * 0.3;
        
        squirrelText.style.filter = `drop-shadow(${shadowX}px 8px ${shadowBlur}px rgba(0, 0, 0, ${shadowOpacity}))`;
    }

    function normalizeAngle(angle) {
        // Normalize to 0-360
        return ((angle % 360) + 360) % 360;
    }

    function isInDeadZone(angle) {
        const normalized = normalizeAngle(angle);
        // Dead zones around 90 and 270 degrees (±20 degrees)
        const deadZoneSize = 20;
        return (
            (normalized > 90 - deadZoneSize && normalized < 90 + deadZoneSize) ||
            (normalized > 270 - deadZoneSize && normalized < 270 + deadZoneSize)
        );
    }

    function findSafeAngle(angle) {
        const normalized = normalizeAngle(angle);
        // Snap to nearest safe angle (0, 180, or continue past dead zone)
        if (normalized > 70 && normalized < 110) {
            // Near 90, snap to 0 or 180
            return normalized < 90 ? 70 : 110;
        }
        if (normalized > 250 && normalized < 290) {
            // Near 270, snap to 180 or 360
            return normalized < 270 ? 250 : 290;
        }
        return angle;
    }

    function animate() {
        if (isDragging) {
            animationId = null;
            return;
        }

        velocity *= friction;
        currentRotation += velocity;

        // Check if we're slowing down enough to stop
        if (Math.abs(velocity) < minVelocity) {
            // Snap to safe angle if in dead zone
            if (isInDeadZone(currentRotation)) {
                const safeAngle = findSafeAngle(currentRotation);
                // Animate to safe position
                const diff = safeAngle - normalizeAngle(currentRotation);
                currentRotation += diff * 0.2;
                
                if (Math.abs(diff) < 0.5) {
                    currentRotation = safeAngle;
                    velocity = 0;
                    squirrelText.style.transform = `rotateY(${currentRotation}deg)`;
                    animationId = null;
                    return;
                }
            } else {
                velocity = 0;
                squirrelText.style.transform = `rotateY(${currentRotation}deg)`;
                animationId = null;
                return;
            }
        }

        squirrelText.style.transform = `rotateY(${currentRotation}deg)`;
        updateShadow(currentRotation);
        animationId = requestAnimationFrame(animate);
    }

    function handleStart(x) {
        isDragging = true;
        lastX = x;
        lastTime = performance.now();
        velocity = 0;
        if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
        }
    }

    function handleMove(x) {
        if (!isDragging) return;
        
        const now = performance.now();
        const deltaX = x - lastX;
        const deltaTime = now - lastTime;
        
        if (deltaTime > 0) {
            velocity = deltaX * 0.5; // Convert to rotation speed
        }
        
        currentRotation += deltaX * 0.5;
        squirrelText.style.transform = `rotateY(${currentRotation}deg)`;
        updateShadow(currentRotation);
        
        lastX = x;
        lastTime = now;
    }

    function handleEnd() {
        isDragging = false;
        // Start momentum animation
        if (Math.abs(velocity) > minVelocity) {
            animationId = requestAnimationFrame(animate);
        } else if (isInDeadZone(currentRotation)) {
            // Even without velocity, snap out of dead zone
            animationId = requestAnimationFrame(animate);
        }
    }

    // Touch events
    squirrelText.addEventListener('touchstart', (e) => {
        e.preventDefault();
        const touch = e.touches[0];
        handleStart(touch.clientX);
    }, { passive: false });

    squirrelText.addEventListener('touchmove', (e) => {
        e.preventDefault();
        const touch = e.touches[0];
        handleMove(touch.clientX);
    }, { passive: false });

    squirrelText.addEventListener('touchend', handleEnd);
    squirrelText.addEventListener('touchcancel', handleEnd);

    // Mouse events
    squirrelText.addEventListener('mousedown', (e) => {
        e.preventDefault();
        handleStart(e.clientX);
    });

    document.addEventListener('mousemove', (e) => {
        handleMove(e.clientX);
    });

    document.addEventListener('mouseup', handleEnd);
});